import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export const AdminQuotes = () => {
  const [quotes, setQuotes] = useState([]);
  useEffect(() => { api.get("/admin/quotes").then((r) => setQuotes(r.data)); }, []);

  if (quotes.length === 0) return <p data-testid="admin-quotes-empty" className="text-sm text-slate-500">Aucune demande de devis.</p>;

  return (
    <div data-testid="admin-quotes" className="grid gap-4 md:grid-cols-2">
      {quotes.map((q) => (
        <div key={q.id} data-testid={`admin-quote-${q.id}`} className="border border-navy/10 bg-white p-6">
          <p className="eyebrow text-royal">{q.service_type}</p>
          <p className="mt-2 font-display font-semibold text-navy">{q.name} {q.company && <span className="font-normal text-slate-500">· {q.company}</span>}</p>
          <p className="text-xs text-slate-500">{q.email} · {q.phone}</p>
          <p className="mt-4 text-sm leading-relaxed text-slate-700">{q.message}</p>
          <p className="mt-4 font-mono text-[11px] text-slate-400">{new Date(q.created_at).toLocaleString("fr-FR")}</p>
        </div>
      ))}
    </div>
  );
};
